var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "perks-widget" },
    [
      _c("categories", { on: { categorySelected: _vm.setCategoryId } }),
      _vm._v(" "),
      _c("offers", { attrs: { category: _vm.category } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }